import { useEffect, useState } from "react"

const QUERY = "(prefers-reduced-motion: reduce)"

export const useReducedMotion = (): boolean => {
  const [reduced, setReduced] = useState<boolean>(false)

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return
    const mql = window.matchMedia(QUERY)
    setReduced(mql.matches)
    const handler = (event: MediaQueryListEvent) => setReduced(event.matches)
    mql.addEventListener("change", handler)
    return () => mql.removeEventListener("change", handler)
  }, [])

  return reduced
}
